import { observer } from 'mobx-react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import React from 'react'
import { observable, toJS } from 'mobx'
import Util from '../../common/Util'
import ApiClient, { ApiRoutes } from '../../api/ApiClient'
import { route } from '../../routes/routes'
import LoadingPanel from '../LoadingPanel'
import _ from 'lodash'

type ResignedMembershipsData = {
  resignedMemberCount: {
    day: number
    month: number
    year: number
  }
}

type Props = {
  filters: {
    state?: string
    areaId?: number
    chapterId?: number
  }
  onShowMemberList: (url: string, title: string) => void
}

@observer
export default class ResignedMembershipsDashboard extends React.Component<Props> {
  @observable
  private resignedMemberships?: ResignedMembershipsData
  @observable
  private error?: string
  @observable
  private loading = false

  componentDidMount () {
    this.loadData().then()
  }

  componentDidUpdate (prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
    if (!_.isEqual(toJS(prevProps.filters), toJS(this.props.filters))) {
      this.loadData().then()
    }
  }

  private loadData = async () => {
    try {
      this.error = undefined
      this.loading = true

      const response = await ApiClient.getInstance().get(route(ApiRoutes.dashboard.resignedMemberships, {}, this.props.filters))

      this.resignedMemberships = response.data

      this.loading = false
    } catch (err) {
      this.error = Util.extractErrorMessage(err.response)
    }
  }

  render () {
    return <Card>
      <CardHeader>
        <b>Resigned Memberships</b>
      </CardHeader>
      <CardBody>
        <LoadingPanel loading={this.loading} loaded={!!this.resignedMemberships} error={this.error}>
          {
            this.resignedMemberships
              ? <>
                <div className="d-flex">
                  <div className="flex-fill">
                    Today
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowMemberList(route(ApiRoutes.dashboard.resignedMemberships, {}, {
                        ...this.props.filters,
                        list: 'day',
                      }), 'Resigned Members Today')
                    }}>
                    {Util.formatNumber(this.resignedMemberships!.resignedMemberCount.day)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    This Month
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowMemberList(route(ApiRoutes.dashboard.resignedMemberships, {}, {
                        ...this.props.filters,
                        list: 'month',
                      }), 'Resigned Members This Month')
                    }}>
                    {Util.formatNumber(this.resignedMemberships!.resignedMemberCount.month)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    This Year
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowMemberList(route(ApiRoutes.dashboard.resignedMemberships, {}, {
                        ...this.props.filters,
                        list: 'year',
                      }), 'Resigned Members This Year')
                    }}>
                    {Util.formatNumber(this.resignedMemberships!.resignedMemberCount.year)}
                    </a>
                  </div>
                </div>
              </>
              : null
          }
        </LoadingPanel>
      </CardBody>
    </Card>
  }
}
